// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"4c1dbc3a","506":"92c70ad9","787":"a542a446"}[chunkId] + ".chunk.js";
};